import { chef, spices, recipe } from '../../../../../index';
import { buttonIcoCloseTpl, buttonIcoDownTpl } from '../../buttons';
import './styles';

const headerTpl = (initData = {}) => {
    return ``
}

export default  headerTpl;